import { render, staticRenderFns } from "./RelatedTasks.vue?vue&type=template&id=00fb0007&scoped=true&"
import script from "./RelatedTasks.vue?vue&type=script&lang=js&"
export * from "./RelatedTasks.vue?vue&type=script&lang=js&"
import style0 from "./RelatedTasks.vue?vue&type=style&index=0&id=00fb0007&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fb0007",
  null
  
)

export default component.exports